export default __webpack_public_path__ + "static/media/WAS0050.34I-35297_-20457_0.8222b4c6.jpg";